'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _carousel = require('./carousel');

var _carousel2 = _interopRequireDefault(_carousel);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselModal = (0, _createReactClass2.default)({
    displayName: 'CarouselModal',
    componentDidMount: function componentDidMount() {
        $('#cm' + this.props.itemId).modal('show');
        $('#cm' + this.props.itemId).on('hidden.bs.modal', this.props.handleHideModal);
    },
    render: function render() {
        var itemName = this.props.itemName;
        var itemDesc = this.props.itemDesc;
        var itemId = this.props.itemId;
        var imgUrl = this.props.imgUrl;
        var mediaArray = this.props.mediaArray;

        return _react2.default.createElement(
            'div',
            {
                className: 'image-carousel-modal modal fade',
                id: 'cm' + itemId,
                tabIndex: '-1',
                role: 'dialog',
                'aria-hidden': 'true',
                style: { display: 'none' }
            },
            _react2.default.createElement(
                'div',
                { className: 'modal-content' },
                _react2.default.createElement(
                    'div',
                    { className: 'close-modal', 'data-dismiss': 'modal' },
                    _react2.default.createElement(
                        'div',
                        { className: 'lr' },
                        _react2.default.createElement('div', { className: 'rl' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-lg-12 reduce-col-pad' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-body carousel-modal-padding' },
                                _react2.default.createElement(
                                    'h2',
                                    null,
                                    itemName
                                ),
                                _react2.default.createElement('hr', { className: 'star-primary' }),
                                _react2.default.createElement('br', null),
                                mediaArray.length <= 1 ? _react2.default.createElement('img', {
                                    src: imgUrl,
                                    className: 'img-responsive center-block',
                                    alt: itemName
                                }) : _react2.default.createElement(_carousel2.default, {
                                    itemName: itemName,
                                    mediaArray: mediaArray
                                }),
                                _react2.default.createElement(
                                    'p',
                                    { style: { marginTop: 15 } },
                                    itemDesc
                                )
                            )
                        )
                    )
                )
            )
        );
    }
});

exports.default = CarouselModal;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/image-handling/carousel-modal.jsx
// module id = 476
// module chunks = 0